import { Fragment, useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { getSubCategory } from "../../../store/slices/categories";
// import CreateSubCategoryModal from "./components/createSubCategoryModal";

const TenantConfiguration = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });

  useEffect(() => {
    getCategoriesData({});
  }, []);

  const getCategoriesData = async (payload) => {
    let data = await dispatch(getSubCategory(payload));
    if (data?.payload) setData(data?.payload);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "ID",
        header: "Sub Category ID",
        size: 150,
      },
      {
        accessorKey: "name",
        header: "Sub Category Name",
        size: 150,
      },
      {
        accessorKey: "description",
        header: "Description",
        size: 150,
      },
      {
        accessorKey: "type",
        header: "Benefit Type",
        size: 150,
      },
      {
        accessorKey: "slug_name",
        header: "Slug Name",
        size: 150,
      },
    ],
    []
  );

  const handlePageChange = useCallback((event) => {
    setPagination(event);
  }, []);

  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        cursor: "pointer",
      },
    }),
    manualPagination: true,
    rowCount: totalCount,
    onPaginationChange: handlePageChange,
    state: { pagination },
    initialState: { density: "compact" },
    renderTopToolbarCustomActions: ({ table }) => (
      <div className="d-flex">
        <div
          sx={{
            display: "flex",
            gap: "16px",
            padding: "8px",
            flexWrap: "wrap",
          }}
        >
          <button className="btn bg-primary" onClick={() => setModalOpen(true)}>
            Create Sub Category
          </button>
        </div>
      </div>
    ),
  });

  const toggle = useCallback(() => {
    getCategoriesData();
    setModalOpen(!isModalOpen);
  }, [isModalOpen]);

  return (
    <Fragment>
      {/* <CreateSubCategoryModal isOpen={isModalOpen} toggle={() => toggle()} /> */}
      <Breadcrumbs mainTitle="Services" parent="Services" title="Services" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <MaterialReactTable table={table} />
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default TenantConfiguration;
